import { gql } from '@apollo/client';

export const UPLOAD_SIGN_OFF_SHEET = gql`
    mutation UploadReflectionPhaseSignOffSheet($id: ID!, $file: Upload!) {
        uploadReflectionPhaseSignOffSheet(id: $id, file: $file) {
            id
        }
    }
`
